// extracted by mini-css-extract-plugin
export default {"root":"NotLoggedIn_root__WVH3Z","title":"NotLoggedIn_title__pRMm1","subtitle":"NotLoggedIn_subtitle__CCNn8"};